<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{ $t('edit.hpInfo.audio') }}</div>
    </div>
    <div class="tool-drawer-content">
      <IconSelect
        :currentIcon="audioObj.icon_url"
        @onSelectIcon="onSelectIcon"
      ></IconSelect>
      <div class="tit-box">
        <div>
          <div style="margin-bottom: 5px">
            <span>{{ $t('edit.hpInfo.IconScale') }}:</span>
          </div>
          <a-row class="titleScaleBg">
            <a-col :span="24">
              <a-slider :min="1" :max="300" :step="1" v-model="currScale" />
            </a-col>
          </a-row>
        </div>

        <div class="tit-desc">
          <span>{{ $t('edit.title') }}</span>
          <a-checkbox
            :checked="audioObj.is_show_title === 1"
            @change="isShowTitle"
          >
            {{ $t('edit.hpInfo.showTitle') }}
          </a-checkbox>
        </div>
        <div style="background-color: #212121">
          <div class="tit-desc-px">
            <a-input
              :placeholder="$t('edit.hpInfo.inputTitle')"
              v-model="currTitle"
            />
            <div class="tit-px">
              <a-input
                class="title-input"
                :placeholder="currFontSize"
                v-model="currFontSize"
              />
              <span style="padding-left: 2px">px</span>
            </div>
          </div>
          <div class="tit_position_bg">
            <a-button
              class="tit_position_btn"
              type="primary"
              v-for="(item, index) in btnPosition"
              :key="index"
              @click="onClickBtn(item, index)"
              :class="{ tit_active: index == currentPosition }"
            >
              {{ item.name }}
            </a-button>
          </div>
        </div>
        <div class="tit_sliderbar_bg">
          <a-row>
            <a-col :span="6" style="padding: 5px">
              {{ $t('edit.hpInfo.title_x') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_x" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" style="padding: 5px">
              {{ $t('edit.hpInfo.title_y') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_y" />
            </a-col>
          </a-row>
        </div>
      </div>
      <div style="margin: 20px">
        <material-select :type="2" @selected="handleSelectedAudio">
          <template slot="body">
            <a-button type="primary" ghost>
              {{ $t('edit.hpInfo.audioSelect') }}
            </a-button>
          </template>
        </material-select>
      </div>

      <div class="image-list" v-if="audioObj.content && audioObj.content.url">
        <audio
          controls="controls"
          alt="example"
          :src="audioObj.content.url"
          preload="none"
        ></audio>
        <div class="material-option">
          <span class="m-title">{{ audioObj.content.name }}</span>
          <span class="m-dele" @click="onClickDel">
            {{ $t('actionTitles.delete') }}
          </span>
        </div>
      </div>
    </div>
    <div class="tool-drawer-btns">
      <DoubleBtn
        @onClickSave="onClickSave"
        @onClickCancel="clickDelete"
      ></DoubleBtn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IconSelect from './IconSelect.vue';
import MaterialSelect from '@/components/MaterialSelect';
import { v4 as uuidv4 } from 'uuid';
import DoubleBtn from '../DoubbleBtn';

export default {
  components: { IconSelect, MaterialSelect, DoubleBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      btnPosition: [
        { name: '上', align: 'top', edge: 'bottom', x: 0, y: 0 },
        { name: '下', align: 'bottom', edge: 'top', x: 0, y: 0 },
        { name: '左', align: 'right', edge: 'right', x: 50, y: 10 },
        { name: '右', align: 'left', edge: 'left', x: 50, y: 10 },
      ],
      currentPosition: 0,
      audioObj: {
        type: 'audio',
        hotspot_id: 'hotspot_' + uuidv4(),
        icon_url: '',
        is_dynamic: 0,
        ath: '',
        atv: '',
        title: '',
        is_show_title: 1,
        content: {},
        titleFontSize: 14,
        tit_position_align: 'top',
        tit_position_edge: 'bottom',
        tit_position_x: 0,
        tit_position_y: 0,
        icon_scale: 50,
      },
      currScale: 50,
      curr_align: 'top',
      curr_edge: 'bottom',
      curr_x: 0,
      curr_y: 0,
      currFontSize: 16,
      currTitle: '',
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          // this.titleStr = value.title
          // this.selectIcon  = value.icon_url
          // this.currentAudio = {name: value.content[0].name, url: value.content[0].img_url}
          this.audioObj = value;
          this.currFontSize = this.audioObj.titleFontSize;
          this.currScale = this.audioObj.icon_scale;
          this.curr_x = this.audioObj.tit_position_x;
          this.curr_y = this.audioObj.tit_position_y;
          this.currTitle = this.audioObj.title;
          if (this.audioObj.tit_position_align == 'top') {
            this.currentPosition = 0;
          } else if (this.audioObj.tit_position_align == 'bottom') {
            this.currentPosition = 1;
          } else if (this.audioObj.tit_position_align == 'left') {
            this.currentPosition = 3;
          } else if (this.audioObj.tit_position_align == 'right') {
            this.currentPosition = 2;
          }
        }
      },
      immediate: true,
      deep: true,
    },
    newAudioObj: {
      handler: function (val, oldVal) {
        if (val.ath == '' && val.atv == '') {
          const vh = getSceneViewAt();
          this.audioObj.ath = vh.hlookat;
          this.audioObj.atv = vh.vlookat;
        }
        this.$emit('change', this.audioObj, oldVal);
      },
      deep: true,
    },
    currFontSize: {
      handler: function (value) {
        const id = this.audioObj.hotspot_id;
        const css = 'css';
        var value =
          'text-align:center; color:#FFFFFF; font-family:MicrosoftYahei; font-size:' +
          value +
          'px';
        setTitlePosition(id, value, css);
      },
      deep: true,
    },
    currTitle: {
      handler: function (value) {
        const id = this.audioObj.hotspot_id;
        setTitle(id, value);
      },
      deep: true,
    },
    currScale: {
      handler: function (value) {
        const id = this.audioObj.hotspot_id;
        setIconScale(id, value);
        // console.log(value);
      },
      deep: true,
    },
    curr_x: {
      handler: function (value) {
        const id = this.audioObj.hotspot_id;
        // const x = 'x';
        // setTitlePosition(id, value, x);

        const axis = 'x';
        // 若左右對立，送反號
        const send = this.isOppositeX(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
    curr_y: {
      handler: function (value) {
        const id = this.audioObj.hotspot_id;
        // const y = 'y'
        // setTitlePosition(id, value, y);

        const axis = 'y';
        // 若上下對立，送反號
        const send = this.isOppositeY(this.curr_align, this.curr_edge)
          ? -value
          : value;
        setTitlePosition(id, send, axis);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['vrbase', 'currentScenesId', 'userInfo']),
    newAudioObj() {
      return this.$deepClone(this.audioObj);
    },
  },
  mounted() {
    this.$bus.$on('updateHotspot', (e) => {
      if (e.hotspot_id == this.audioObj.hotspot_id) {
        this.audioObj.ath = e.ath;
        this.audioObj.atv = e.atv;
      }
    });
  },
  methods: {
    isOppositeY(align, edge) {
      return align === 'bottom' && edge === 'top';
    },
    isOppositeX(align, edge) {
      return align === 'right' && edge === 'left';
    },
    onClickBtn(item, index) {
      this.currentPosition = index;
      const currId = this.audioObj.hotspot_id;

      // 重新把目前的 x/y（滑桿數值）送進 krpano，但在送之前做對立翻號
      const sendX = this.isOppositeX(this.curr_align, this.curr_edge)
        ? -this.curr_x
        : this.curr_x;
      const sendY = this.isOppositeY(this.curr_align, this.curr_edge)
        ? -this.curr_y
        : this.curr_y;

      // 再把調整後的位移送進 krpano
      setTitlePosition(currId, sendX, 'x');
      setTitlePosition(currId, sendY, 'y');

      setHotspotTitlePosition(item, currId);
      this.curr_align = item.align;
      this.curr_edge = item.edge;
      this.curr_x = item.x;
      this.curr_y = item.y;
    },
    onSelectIcon(item) {
      // this.selectIcon = item.icon_url;
      this.audioObj.icon_url = item.icon_url;
      this.audioObj.is_dynamic = item.is_dynamic;
    },
    handleChange() {},
    onChange() {},
    isShowTitle(e) {
      this.audioObj.is_show_title = e.target.checked ? 1 : 0;
    },

    clickBack() {
      this.$emit('clickBack', this.audioObj);
    },
    clickDelete() {
      this.$emit('clickDelete', this.audioObj);
    },
    handleSelectedAudio(value) {
      this.audioObj.content = { name: value.name, url: value.url };
    },
    onClickSave() {
      if (!this.audioObj.icon_url) {
        this.$message.error(this.$t('edit.hpInfo.hpIcon'));
        return;
      }
      if (!this.currTitle) {
        this.$message.error(this.$t('edit.hpInfo.inputTitle'));
        return;
      }
      if (!this.audioObj.content.name) {
        this.$message.error(this.$t('edit.hpInfo.audioSelect'));
        return;
      }
      this.audioObj.title = this.currTitle;
      this.audioObj.titleFontSize = this.currFontSize;
      this.audioObj.icon_scale = this.currScale;
      this.audioObj.tit_position_align = this.curr_align;
      this.audioObj.tit_position_edge = this.curr_edge;
      this.audioObj.tit_position_x = this.curr_x;
      this.audioObj.tit_position_y = this.curr_y;
      this.$emit('saveDataToStore', {
        key: this.audioObj.hotspot_id,
        data: this.audioObj,
      });
    },
    onClickDel() {
      this.audioObj.content = {};
    },
  },
};
</script>

<style lang="less" scoped>
.image-list {
  padding: 10px 4px;
  text-align: center;
  width: 230px;
}
.image-list audio {
  width: 100%;
}
.material-option {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 4px;
  cursor: pointer;
}
.m-title {
  width: 180px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.m-dele {
  width: 30px;
}
.title-input {
  text-align: center;
  width: 50%;
}
.tit-desc-px {
  display: inline-flex;
  align-items: center;
  padding: 5px;
}
.tit-px {
  text-align: right;
}
.title-type {
  width: 80%;
}
.tit_position_bg {
  height: 49px;
  background-color: #212121;
  width: 100%;
  display: flex;
  .positionBtn.tit_active {
    background-color: #7101ad;
    border-color: #7101ad;
  }
  .positionBtn:hover {
    background-color: #d485ff;
    border-color: #d485ff;
  }
}
.tit_position_btn {
  color: #fff;
  background-color: #404040;
  border-color: #2e2e2e;
  margin: 10px 4px;
  border: 1px solid;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #555;
}
.tit_position_btn:hover {
  background-color: #02a2aa;
  border-color: #02a2aa;
  border: 1px solid #fff;
}
.tit_active {
  background-color: #015c61;
  border-color: #015c61;
}
.tit_sliderbar_bg {
  height: auto;
  background-color: #212121;
  width: 100%;
}
.titleScaleBg {
  background-color: #212121;
}
</style>
